/*
╔═╗┌─┐┌─┐┬─┐┌─┐┌─┐┬┌─┬ ┬┌┬┐┌┬┐┬ ┬
║ ╦├┤ │ │├┬┘│ ┬├┤ ├┴┐│ │ │  │ └┬┘
╚═╝└─┘└─┘┴└─└─┘└─┘┴ ┴└─┘ ┴  ┴  ┴ 
DesignedAndDevelopedBy:Georgekutty @21-07-2019 20:16:56
*/

import { combineReducers } from 'redux';
import isUserLoggedIn from './isUserLoggedIn';
import isSwitchAccountModalVisible from './isSwitchAccountModalVisible';
import locales from './locales';
import cache from './cache';
import currentPage from './currentPage';
import registerDetails from './registerDetails';
import orderDetails from './saveOrderDetails';
import planDetails from './planDetails';
import userRegisterDetails from './userRegisterDetails';
import userDetails from './userDetails';
import loginPage from './loginPage';
import siteKey from './siteKey';
import forgetPasswordDetails from './forgetPasswordDetails';
import contextParameters from './contextParameters';
import feasibilityResposnse from './feasibilityResposnse';
import changeEquipmentDetails from './changeEquipmentDetails';
import configurationValues from './configurationValues'

const reducers = combineReducers({
  isUserLoggedIn:isUserLoggedIn,
  locales:locales ,
  cache:cache,
  currentPage:currentPage,
  registerDetails:registerDetails,
  planDetails:planDetails,
  userRegisterDetails:userRegisterDetails,
  userDetails:userDetails,
  loginPage:loginPage,
  forgetPasswordDetails:forgetPasswordDetails,
  isSwitchAccountModalVisible:isSwitchAccountModalVisible,
  contextParameters:contextParameters,
  feasibilityResposnse:feasibilityResposnse,
  orderDetails:orderDetails,
  changeEquipmentDetails:changeEquipmentDetails,
  configurationValues:configurationValues,
  siteKey:siteKey
})

export default reducers


